import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '@ui-nuvertos/shared';

@Injectable({
  providedIn: 'root'
})
export class SubsidiaryService {
  private accountingUrl = environment.accountingUrl;

  constructor(private http: HttpClient, private cookieService: CookieService) {}

  // Get subsidiaries, optional query params (e.g., include_inactive)
  getSubsidiaries(params?: { [param: string]: string | string[] }): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/subsidiaries/`;
    const httpOptions = { params: new HttpParams({ fromObject: params || {} }), withCredentials: true };
    return this.http.get<any>(url, httpOptions);
  }

  // Get subsidiaries by IDs (POST method)
  getSubsidiariesByIds(ids: string[]): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/subsidiaries/bulk`;
    return this.http.post<any>(url, { ids }, { withCredentials: true });
  }

  // Get subsidiary by ID
  getSubsidiaryById(id: string | number): Observable<any> {
    const url = `${this.accountingUrl}/api/v1/subsidiaries/${id}`;
    return this.http.get<any>(url, { withCredentials: true });
  }
}

